import React, { useEffect } from "react";
import { X } from "lucide-react";

export default function Lightbox({ src, caption, onClose }) {
  useEffect(() => {
    if (!src) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [src, onClose]);

  if (!src) return null;

  return (
    <div
      data-testid="lightbox-overlay"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/90 backdrop-blur-md p-4 sm:p-10 animate-[fadeIn_0.25s_ease]"
      onClick={onClose}
    >
      <button
        data-testid="lightbox-close"
        onClick={onClose}
        className="absolute top-5 right-5 text-parchment/70 hover:text-gold transition-colors"
        aria-label="Close"
      >
        <X className="w-8 h-8" />
      </button>
      <figure className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
        <img
          src={src}
          alt={caption || ""}
          className="w-full max-h-[80vh] object-contain border border-gold/20 shadow-2xl"
        />
        {caption && (
          <figcaption className="mt-4 text-center font-display italic text-lg text-parchment/85">
            {caption}
          </figcaption>
        )}
      </figure>
    </div>
  );
}
